// startup
// Load entry module
__webpack_require__("./lib/DecoderBootstrap.ts");
// This entry module used 'exports' so it can't be inlined
